import apiClient from '../utils/axios'

// Auth API
export const authAPI = {
  login: (credentials) => apiClient.post('/auth/login', credentials),
  refresh: (refreshToken) => apiClient.post('/auth/refresh', { refresh_token: refreshToken }),
  me: () => apiClient.get('/user/profile'),
  forgotPassword: (email) => apiClient.post('/auth/forgot-password', { email }),
  resetPassword: (data) => apiClient.post('/auth/reset-password', data),
  changePassword: (data) => apiClient.post('/user/change-password', data),
}

// Meta Assets API
export const metaAssetsAPI = {
  getAssets: (params) => apiClient.get('/meta/assets', { params }),
  getAssetsByType: (assetType, params) => apiClient.get(`/meta/assets/type/${assetType}`, { params }),
  getAsset: (assetId) => apiClient.get(`/meta/assets/${assetId}`),
  deleteAsset: (assetId) => apiClient.delete(`/meta/assets/${assetId}`),
  syncAssets: () => apiClient.get('/meta/assets/sync')
}

// WhatsApp Numbers API
export const whatsAppNumbersAPI = {
  getAll: (params) => apiClient.get('/meta/whatsapp-numbers', { params }),
  getOne: (id) => apiClient.get(`/meta/whatsapp-numbers/${id}`),
  create: (data) => apiClient.post('/meta/whatsapp-numbers', data),
  update: (id, data) => apiClient.put(`/meta/whatsapp-numbers/${id}`, data),
  delete: (id) => apiClient.delete(`/meta/whatsapp-numbers/${id}`),
}

// WhatsApp API
export const whatsAppAPI = {
  sendMessage: (fromUserId, toUserId, message) =>
    apiClient.post(`/meta/whatsapp/chat/${fromUserId}/${toUserId}`, { messages: message }),
  sendTemplateMessage: (data) =>
    apiClient.post('/meta/whatsapp/send-template-message', data),
  getUsers: (phoneNumber) =>
    apiClient.get(`/meta/whatsapp/users/${phoneNumber}`),
  getUserMessages: (fromUserId, toUserId) =>
    apiClient.get(`/meta/whatsapp/chat/${fromUserId}/${toUserId}`),
  createTemplate: (assetId, templateData) =>
    apiClient.post(`/meta/templates/${assetId}`, templateData),
  getTemplates: (assetId) =>
    apiClient.get(`/meta/templates/${assetId}`),
  syncTemplates: (assetId) =>
    apiClient.get(`/meta/templates/sync/${assetId}`),
  deleteTemplate: (templateId) =>
    apiClient.delete(`/meta/templates/${templateId}`),
}

// Telegram API
export const telegramAPI = {
  getUsers: () => apiClient.get('/telegram/users'),
  getUser: (identifier) => apiClient.get(`/telegram/users/${identifier}`),
}

// Social Accounts API
export const socialAccountsAPI = {
  getAccounts: (params) => apiClient.get('/social-accounts', { params }),
  getAccount: (id) => apiClient.get(`/social-accounts/${id}`),
  getAccountByProvider: (provider) => apiClient.get(`/social-accounts/${provider}`),
  createAccount: (data) => apiClient.post('/social-accounts', data),
  updateAccount: (id, data) => apiClient.put(`/social-accounts/${id}`, data),
  deleteAccount: (id) => apiClient.delete(`/social-accounts/${id}`),
}

// Data API
export const dataAPI = {
  getAll: () => apiClient.get('/data/all'),
}

// Contacts API
export const contactsAPI = {
  getAll: (params) => apiClient.get('/contacts', { params }),
  getOne: (id) => apiClient.get(`/contacts/${id}`),
  create: (data) => apiClient.post('/contacts', data),
  update: (id, data) => apiClient.put(`/contacts/${id}`, data),
  delete: (id) => apiClient.delete(`/contacts/${id}`),
  bulkAssignGroup: (data) => apiClient.post('/contacts/bulk-assign-group', data),
  downloadTemplate: () => apiClient.get('/contacts/import/template', { responseType: 'blob' }),
  import: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post('/contacts/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  export: (params) => apiClient.get('/contacts/export', { params, responseType: 'blob' }),
}

// Contact Groups API
export const contactGroupsAPI = {
  getAll: (params) => apiClient.get('/contact-groups', { params }),
  getOne: (id) => apiClient.get(`/contact-groups/${id}`),
  create: (data) => apiClient.post('/contact-groups', data),
  update: (id, data) => apiClient.put(`/contact-groups/${id}`, data),
  delete: (id) => apiClient.delete(`/contact-groups/${id}`),
}

